import { Controller } from "@hotwired/stimulus"

// Dispara evento custom quando o form de "Testar conexão" submete,
// pra que o integra_status_controller comece a fazer polling.
export default class extends Controller {
  start() {
    document.dispatchEvent(new CustomEvent("integra:test-started"))
  }
}
